import {
  faExclamationTriangle,
  faQuestionCircle,
  IconDefinition,
} from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React from 'react';
import styled from 'styled-components';
import Spacer from './Spacer';

const Container = styled.div<{ background: string }>`
  background: ${(props) => props.background};
  padding: 12px 18px;
  border-radius: 5px;
  display: flex;
  align-items: center;
`;

const Content = styled.div<{ color: string }>`
  font-size: 14px;
  font-weight: 300;
  color: ${(props) => props.color};
`;

type HelpType = 'help' | 'warning';
type Props = {
  children?: React.ReactNode;
  type?: HelpType;
};

const variants: {
  [key: string]: {
    background: string;
    iconColor: string;
    icon: IconDefinition;
    fontColor: string;
  };
} = {
  help: {
    background: '#F8F9FF',
    iconColor: '#9092c1',
    icon: faQuestionCircle,
    fontColor: '#9092c1',
  },
  warning: {
    background: '#ffecd0',
    iconColor: '#ffa823',
    icon: faExclamationTriangle,
    fontColor: '#807564',
  },
};

export function HelpText({ children, type = 'help' }: Props) {
  return (
    <Container background={variants[type].background}>
      <FontAwesomeIcon
        icon={variants[type].icon}
        color={variants[type].iconColor}
      />
      <Spacer horizontal spacing={2} />
      <Content color={variants[type].fontColor}>{children}</Content>
    </Container>
  );
}
